import React, { useState, useMemo } from 'react';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import * as PropTypes from 'prop-types';
import useClientsEventBookingGql from './hooks/useClientsEventBookingGql';
import useClientsEventBookingContext from './hooks/useClientsEventBookingContext';
import ClientsEventBookingContext from './hooks/ClientsEventBookingContext';

function BookingPagesWrapper({ children }) {
  const { useParams } = useAppContext();
  const { gid } = useParams();
  const [isBlocking, setIsBlocking] = useState(false);

  const toggleBlocking = useMemo(
    () => setIsBlocking((current) => !current),
    [],
  );

  const { useClientsEventBookingNodeQuery } = useClientsEventBookingGql();
  const { clientsEventBooking: old, setClientsEventBooking, ...remaining } = useClientsEventBookingContext();

  const { data, loading } = useClientsEventBookingNodeQuery(gid);

  if (loading) return null; // TODO ADD LOADING SCREEN

  const { node: clientsEventBooking } = data;
  return (
    <ClientsEventBookingContext.Provider value={{ clientsEventBooking, setClientsEventBooking, ...remaining, isBlocking, toggleBlocking }}>
      {children}
    </ClientsEventBookingContext.Provider>
  );
}

BookingPagesWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default BookingPagesWrapper;
